// components/Footer.tsx
import React from 'react';

const FooterComponent: React.FC = () => {
  return (
    <footer className="App-footer">
      <a href={"https://www.iubenda.com/privacy-policy/65861279"}>Privacy policy</a>
    </footer>
  );
}

export default FooterComponent;
